/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-alert */

// import node_modules
import * as React from 'react';
import { useTranslation } from 'react-i18next';

// import config
import { cookiesBaseDomain } from '../../../config';

// define component
const PrivacyActions: React.FunctionComponent = () => {
  // import hooks
  const { t } = useTranslation('components');

  // custom func
  const onFbOptOut = React.useCallback(() => {
    // because of build
    if (typeof window === 'undefined') return;

    // set localStorage
    localStorage.setItem('adCookies', 'opt-out');

    // update cookie status for subdomains
    const baseDomain = cookiesBaseDomain;
    const expireAfter = new Date();

    // setting up cookie expire date after a month
    expireAfter.setDate(expireAfter.getDate() + 30);

    // now setup cookie for subdomains
    const cookieStatus = localStorage.getItem('performanceCookies') === 'opt-in';
    document.cookie = `rootCookies={ performance: ${cookieStatus}, ad: false }; domain=${baseDomain}; expires=${expireAfter}; path=/`;

    // alert an refresh page
    alert(t('PrivacyActions.alerts.facebookPixel'));
    window.location.reload();
  }, [t]);

  // handle data changes
  React.useEffect(() => {
    // get and check button
    const fbOptOutButton = document.getElementById('faOptOut');

    // listen to ga optout event
    if (fbOptOutButton) {
      fbOptOutButton.addEventListener('touchstart', onFbOptOut);
      fbOptOutButton.addEventListener('click', onFbOptOut);
    }

    return () => {
      // listen to ga optout event
      if (fbOptOutButton) {
        fbOptOutButton.removeEventListener('touchstart', onFbOptOut);
        fbOptOutButton.removeEventListener('click', onFbOptOut);
      }
    };
  }, [onFbOptOut, t]);

  return <></>;
};

export default PrivacyActions;
